import { Badge as MuiBadge, BadgeOrigin, Stack, styled } from '@mui/material'
import { BadgeCheckIcon } from '$common/icons/badge-check'

const BadgeContainer = styled(Stack)`
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.palette.white};
  background-color: ${({ theme }) => theme.palette.success500};
`

export function SelectedBadge() {
  return (
    <BadgeContainer>
      <BadgeCheckIcon />
    </BadgeContainer>
  )
}

interface BadgeProps {
  selected: boolean
}

const Badge = styled(MuiBadge)<BadgeProps>`
  &.MuiBadge-root {
    width: fit-content;
    height: fit-content;
    padding: 0;
    outline: ${({ theme, selected }) =>
      selected ? `2px solid ${theme.palette.success500}` : 'unset'};
    border: ${({ selected }) => (selected ? '2px solid transparent' : 'unset')};
    border-radius: 50%;
  }
`

export const BadgeWrapper = ({
  selected,
  children,
  anchorOrigin,
}: {
  selected: boolean
  children: JSX.Element
  anchorOrigin?: BadgeOrigin
}) => {
  return (
    <Badge
      selected={selected}
      overlap="circular"
      invisible={!selected}
      anchorOrigin={anchorOrigin}
      badgeContent={selected ? <SelectedBadge /> : null}
    >
      {children}
    </Badge>
  )
}

BadgeWrapper.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
}
